import DimensionResolver from '@/composables/charts/influx-charts/dimension-resolvers/DimensionResolver.js'
import { useInstanceStore } from '@/store/backendInstances.js'
import { useNetworkDeviceStore } from '@/store/networkDevices.js'


class NetworkDeviceDimensionResolver extends DimensionResolver {
  async doesTagKeyMatch(tag) {
    return ['vms', 'netPower16P', 'rut951', 'rut950', 'rut240'].includes(tag)
  }

  async prepareResolver() {
    await super.prepareResolver()
    this.networkDevices = await useNetworkDeviceStore().queryNetworkDevices({projection: {only: ["networkDeviceId", "deviceName"]}})
  }

  async humanizeTagValue(tagValue) {
    const device = this.networkDevices.find(device => device.networkDeviceId === tagValue)
    if (device) {
      return device.deviceName
    }
    return "Unknown Network Device " + tagValue
  }
  static isRelevantForCurrentInstance() {
    return useInstanceStore().selectedInstance.instanceType === 'barn'
  }
}

export default NetworkDeviceDimensionResolver
